export const arrData = [
  // {
  //   thumbnail: "",
  //   name: "Vishall Kumar",
  //   through: "by @palkagrecha",
  //   point: [],
  //   type: "personal",
  //   underType: "insta",
  //   videoLink:
  //     "https://res.cloudinary.com/dxhvvxfqf/video/upload/v1702271191/Website%20Videos/Personal/Mobility_of_Tomorrow_bohnao.mp4",
  // },
      {
        "name": "India Grows with Salesforce",
        "through": "by Salesforce",
        "point": [
          "India Grows with Salesforce – AR Magazine Photobooth",
          "Agency Partner: Blue Pebble",
          "Campaign Concept: An in-house AR activation for Salesforce employees to pose like Rahul Dravid on a magazine cover.",
          "Activation Locations: 4 different Salesforce office locations across Pan India",
          "Technology Used: Snapchat's Camera Kit SDK",
          "Experience Flow:",
          "Employees stood in front of the AR Photobooth.",
          "Entered their name and chose from 10+ magazine cover templates.",
          "A 5-second countdown started for posing like Rahul Dravid.",
          "The AR photobooth captured the image and generated a QR code.",
          "Employees scanned the QR code to download their photo.",
          "They uploaded the photo on LinkedIn with #IndiaGrowsWithSalesforce.",
          "Results & Impact:",
          "Massive Employee Advocacy: Over 500+ organic LinkedIn posts.",
          "2,50,000+ high impressions on LinkedIn.",
          "28,000+ reactions on employee-shared posts.",
          "Employees loved the AR experience – it felt surreal posing with Rahul Dravid."
        ],
        "tryIt": "https://www.snapchat.com/unlock/?type=SNAPCODE&uuid=4ea8efaadab645018b81c19faf00bb62&metadata=01",
        "type": "client",
        "underType": "snap",
        "videoLink": "https://res.cloudinary.com/dswdltf3l/video/upload/v1741344053/Effect%20Videos/Client%20Work/salesforce-Preview_ljblx6.mp4",
        "thumbnail": "https://res.cloudinary.com/dswdltf3l/image/upload/v1741343836/Thumbnails/salesforce-Thumbnail_fulskw.png"
    },

    {
      "name": "Dare to Slurp",
      "through": "by Knorr India",
      "point": [
        "Dare to Slurp – Netflix's Squid Game X Knorr India",
        "Agency Partner: 4 Lunches",
        "Campaign Concept: A thrilling mix of Squid Game and Knorr's ramen Slurp experience",
        "Product: Knorr India's Limited Edition Korean ramen",
        "Game Mechanics:",
        "Entry: Scan the QR code on the ramen pack to access the microsite and enroll.",
        "Objective: Slurp noodles and follow Squid Game's 'Green Light, Red Light' mechanics.",
        "Rules:",
        "Find a quiet place.",
        "Slurp the noodles while facing the camera.",
        "Slurp at Green Light & Freeze at Red Light – Young-hee doll is watching!",
        "Earn Slurp Coins to increase your Slurp Score.",
        "If you don’t slurp for 5 seconds, the Frontman warns you to continue, or you’ll be eliminated.",
        "Slurping during Red Light? Eliminated!",
        "Rewards & Leaderboard:",
        "Higher Slurp Scores increase the chances of winning:",
        "  - A trip to Seoul",
        "  - Exclusive Squid Game & Knorr merchandise",
        "Submit your score and check your ranking on the leaderboard."
      ],
      "tryIt": "https://www.knorr.in/squid-game/dare-to-slurp.html",
      "type": "client",
      "underType": "Web-AR",
      "videoLink": "https://res.cloudinary.com/dswdltf3l/video/upload/v1741266928/Effect%20Videos/Client%20Work/squidgamePreviewOptimised_jb6lfj.mp4",
      "thumbnail": "https://res.cloudinary.com/dswdltf3l/image/upload/v1741267484/Thumbnails/SquidGameThumbnail_jmtflj.jpg"
  },
  {
    name: "Sunlight-oitijhyerrawng",
    through: "by @Sunlight",
    point: [
      "We created this print media AR experinece for Sunlight, the oldest brand of HUL India.",
      "Agency Partner: 4 Lunches",
      "We built this Web AR experience using 8th Wall and it is Activated via QR code printed in a newspaper ad",
      "It was launched during the Durga Pujo celebration in Kolkata's Santosh Mitra Square.",
      "Sunlight aimed to showcase an LED Sphere-style advertisement, similar to Las Vegas visuals",
      "We designed an AR experience for users unable to visit the venue physically, which allowed users to explore an immersive world AR experience in their own surroundings",
    ],
    tryIt: "https://8th.io/8ct4g",
    type: "client",
    underType: "Web-AR",
    videoLink:
      "https://res.cloudinary.com/dswdltf3l/video/upload/v1740465391/Effect%20Videos/Client%20Work/sunlight_Preview_jbuwfg.mp4",
    thumbnail:
      "https://res.cloudinary.com/dswdltf3l/image/upload/v1740473441/Thumbnails/SunlightThumbnail_i2ekdt.png",
  },
  {
    name: "#CycleForGreen",
    through: "by @taiwanexcellence_in",
    point: [
      "We created an AR Instagram gaming effect in collaboration with Blue Pebble for Taiwan Excellence",
      "We designed as part of the Green Wheel Mission to promote eco-friendly transportation and reduce carbon emissions",
      "It features a mascot riding a bicycle, collecting golden and silver coins.",
      "Users control the mascot by tilting their head left or right to navigate the game.",
      "We crafted visually appealing, eco-conscious game elements to complement the campaign's message.",
    ],
    tryIt: "https://www.instagram.com/ar/1026731929199090",
    type: "client",
    underType: "insta",
    videoLink:
      "https://res.cloudinary.com/dswdltf3l/video/upload/v1740419342/Effect%20Videos/Client%20Work/Video-553_qwo5sy.mp4",
    thumbnail:
      "https://res.cloudinary.com/dswdltf3l/image/upload/v1740419768/Thumbnails/TaiwanExcellenceThumbnail_kjdmig.png",
  },
  {
    name: "Surreal Spring",
    through: "by @Ottno.tech",
    point: [
      "We created this amazing AR Lens for Snapchat India X Goafest 2024 in collaboration with Ottno.tech",
      "It gives Surreal Spring experience to the users in their surrounding.",
    ],
    tryIt: "https://snapchat.com/t/7mjBfb0F",
    type: "client",
    underType: "snap",
    videoLink:
      "https://res.cloudinary.com/dswdltf3l/video/upload/v1739285279/Effect%20Videos/Client%20Work/SurrealSpring_qwefgy.mp4",
    thumbnail:
      "https://res.cloudinary.com/dswdltf3l/image/upload/v1739286110/Thumbnails/SurrealSpringThumbnail_xdktft.png",
  },
  {
    name: "WonderChef",
    through: "by @palkagrecha",
    point: [
      "This AR Effect is created for the famous Content Creator Wondermunna.",
      "It was part of #SPARK_CREATION project in collaboration with Meta India.",
      "For all the pizza lovers, are you excited to make your favourite pizza?",
      "Try this AR Effect and get a chance to showcase your inner WonderChef.",
    ],
    tryIt: "https://www.instagram.com/ar/658234642544445/",
    type: "client",
    underType: "insta",
    videoLink:
      "https://res.cloudinary.com/dxhvvxfqf/video/upload/v1702271007/Website%20Videos/Client/WonderChef_hethln.mp4",
    thumbnail:
      "https://res.cloudinary.com/dxhvvxfqf/image/upload/f_auto,q_auto/v1/Thumbnails/WonderChef_zenkjr",
  },
  {
    name: "Diwali Rangoli",
    through: "by @palkagrecha",
    point: [
      "This Diwali, dive into the nostalgia of creating Rangoli with your loved ones through our groundbreaking connected lens experience! 🎨🤝",
      "Thrilled to share that Krunal and I have crafted a unique way to relive the joy of Rangoli making, bringing everyone together no matter where you are! 🌍💫",
      "🔴Here's how the magic unfolds:",
      "1.Open the Snapchat app.",
      "2.Click on the lens explorer.",
      "3.Search for Diwali Rangoli & open the Lens.",
      "4.Start a session with a group and invite your friends to join.",
      "5.Ask your friends to do the same, and in no time, you're all in the same creative session! 🎉",
      "6.Choose your favourite colour and drop it into the rangoli section to see it appear in your friend's rangoli! 😍🌈All of this is made possible by the incredible Snap AR's Sync Framework! 🚀",
    ],
    tryIt:
      "https://www.snapchat.com/unlock/?type=SNAPCODE&uuid=e916778388ca4240bb98d28227cd4c3a&metadata=01",
    type: "client",
    underType: "snap",
    videoLink:
      "https://res.cloudinary.com/dxhvvxfqf/video/upload/v1702271005/Website%20Videos/Client/DiwaliRangoli_a0nz7k.mp4",
    thumbnail: "",
  },
  {
    name: "Uncharted Game",
    through: "by @palkagrecha",
    point: [
      "An immersive gaming experience created for the client SONY Pictures India, the top Hollywood Studio in India, for the recent movie “Uncharted”.",
      "This AR Gaming Effect was created in collaboration with Experiential Etc.",
      "The gaming experience starts by blowing a kiss.",
      "User need to tilt their head from side to side to collect the treasure coins and avoid from the stones (obstacles) at the same time.",
      "The user has 3 lifelines to collect the treasure and score highest.",
    ],
    tryIt: "https://www.instagram.com/ar/358064629446587/",
    type: "client",
    underType: "insta",
    videoLink:
      "https://res.cloudinary.com/dxhvvxfqf/video/upload/v1702270995/Website%20Videos/Client/UnchartedGame_qn0sam.mp4",
    thumbnail:
      "https://res.cloudinary.com/dxhvvxfqf/image/upload/f_auto,q_auto/v1/Thumbnails/Uncharted_Game_bxic4i",
  },
  {
    name: "Review a Movie",
    through: "by @palkagrecha",
    point: [
      "This AR Effect was created in collaboration with [Meta India](https://www.instagram.com/metaindia/).",
      "Love watching cinema and talking about it?",
      "#ReviewAMovie on reels.",
      "Users can share their movie experience using this AR Effect which is created for an e-sports creators aka Triggered Insaan",
    ],
    tryIt: "https://www.instagram.com/ar/1313762435835008/",
    type: "client",
    underType: "insta",
    videoLink:
      "https://res.cloudinary.com/dxhvvxfqf/video/upload/v1702270995/Website%20Videos/Client/Review_A_Movie_Demo_Video_14s_fpcdbi.mp4",
    thumbnail:
      "https://res.cloudinary.com/dxhvvxfqf/image/upload/f_auto,q_auto/v1/Thumbnails/Review_a_Movie_idbjvg",
  },
  {
    name: "My Winter Look Lens",
    through: "by @palkagrecha",
    point: [
      "This lens was created for Flipkart, in collaboration with i-Create.",
      "A photobooth try-on engagement lens.",
      "As beanies are a great way to signify winters.",
      "When the user starts recording, Beanies start shuffling in random sequence.",
      "At random a beanie gets selected.",
      "A notification pops up for the user to get ready to click with the polaroid frame after the counter.",
    ],
    tryIt: "https://lens.snapchat.com/43a1d23c71eb4942a879fb3905210a6d",
    type: "client",
    underType: "snap",
    videoLink:
      "https://res.cloudinary.com/dxhvvxfqf/video/upload/v1702270984/Website%20Videos/Client/MyWinterLookLens_qequqj.mp4",
    thumbnail:
      "https://res.cloudinary.com/dxhvvxfqf/image/upload/f_auto,q_auto/v1/Thumbnails/myWinterLook_mctpaa",
  },
  {
    name: "Mumbai Indians Jersey Try-On",
    through: "by @palkagrecha",
    point: [
      "We at Experiential Etc created this MI Jersey Try-On lens for Mumbai Indians, the team playing IPL 2023.",
      "It was a photo-booth Jersey Try-On lens.",
      "Users can try all the jersey's from the start of the IPL i.e. 2008 till the current year i.e. 2023.",
      "Check out the showreel of our lens on our YouTube page",
    ],
    tryIt:
      "https://www.snapchat.com/unlock/?type=SNAPCODE&uuid=a43f7b25a418449095b182db2b21faf0&metadata=01",
    type: "client",
    underType: "snap",
    videoLink:
      "https://res.cloudinary.com/dxhvvxfqf/video/upload/v1702270984/Website%20Videos/Client/MI_Jersey_Try-On_qvz4em.mp4",
    thumbnail:
      "https://res.cloudinary.com/dxhvvxfqf/image/upload/f_auto,q_auto/v1/Thumbnails/MI_Jersey_Try-On_rasmkd",
  },
  // {
  //   name: "Rahul Kumar",
  //   through: "by @palkagrecha",
  //   point: [],
  //   type: "personal",
  //   underType: "snap",
  //   videoLink:
  //     "https://res.cloudinary.com/dxhvvxfqf/video/upload/v1702271189/Website%20Videos/Personal/Rollover_Donut_rgov9a.mp4",
  // },
  {
    name: "Henna ARt",
    through: "by @palkagrecha",
    point: [
      "Henna-ARt, has won the second prize in the prestigious Indian Summer Lensathon 2023 hosted by Snap AR and Hack2skill! 🎉🎉.",
      "Get ready to experience an immersive AR experience that celebrates the diverse trends of Indian culture in a creative way!",
      "This lens lets you design your very own #henna pattern and see how it would look on your hands - all thanks to Snapchat's 3D hand-tracking solution! I programmed the user interaction flow while Roman focused on creating aesthetic UI elements and melody to enhance the overall experience.",
      "Try the effect for yourself. We had a blast creating it and can't wait for you to try it out! Don't miss out on the fun!",
    ],
    tryIt:
      "https://www.snapchat.com/unlock/?type=SNAPCODE&uuid=b8e83c693ee64fd7a966434783496bbc&metadata=01",

    type: "personal",
    underType: "snap",
    videoLink:
      "https://res.cloudinary.com/dxhvvxfqf/video/upload/f_auto:video,q_auto/v1/Website%20Videos/Personal/HennaARtPreview_vjqazs",
    thumbnail:
      "https://res.cloudinary.com/dxhvvxfqf/image/upload/f_auto,q_auto/v1/Thumbnails/Henna-ARt_vrilyk",
  },
  {
    name: "Be a Paraglider",
    through: "by @palkagrecha",
    point: [
      "This AR Effect uses a microphone as an input with an audio analyzer patch functionality.",
      "It is an audio-based game where the user's voice is taken as input to control the peak of the mascot (Zobu) which can be seen in the paragliding outfit.",
      "The more intense the user's voice frequency, the higher goes the Zobu.",
      "To control the horizontal movement of the Zobu, the user needs to tilt their head.",
      "To keep playing, they need to dodge the trees, and to increase the score, they need to collect the badges.",
      "The score is displayed over the head of the user.",
      "All the gaming instructions are given at the start of the game.",
    ],
    tryIt: "https://www.instagram.com/ar/235912797902003/",
    type: "client",
    underType: "insta",
    videoLink:
      "https://res.cloudinary.com/dxhvvxfqf/video/upload/v1702270977/Website%20Videos/Client/Be_a_Paraglider_fpqbqn.mp4",
  },
  {
    name: "Happy Navratri",
    through: "by @palkagrecha",
    point: [
      "The user activates the rear camera to start the lens experience and the instruction card appears prompting the user to tap to place.",
      "One the user taps, the pot comes bursting through the ground, with debris flying into the air and heavenly rays of light shining bright through the cavity.",
      "Other elements like the rangoli pattern animate into the scene, covering up the cavity, the diyas, bells, lamps and the Happy Navaratri text animate into the scene subsequently.",
    ],
    tryIt:
      "https://www.snapchat.com/unlock/?type=SNAPCODE&uuid=b9cd552f22a649fdb25f9643ff74dbd7&metadata=01",
    type: "personal",
    underType: "snap",
    videoLink:
      "https://res.cloudinary.com/dxhvvxfqf/video/upload/v1702271173/Website%20Videos/Personal/Happy_Navratri_lgxgvj.mp4",
    thumbnail:
      "https://res.cloudinary.com/dxhvvxfqf/image/upload/f_auto,q_auto/v1/Thumbnails/Happy_Navratri_fqvgs1",
  },
  {
    name: "World Water Day",
    through: "by @palkagrecha",
    point: [
      "This is a custom landmark Lens created for the occasion of World Water Day.",
      "This experience was located at Dumas Beach, Surat, Gujarat.",
      "Aim of this lens was to educate citizens about World Water Day fosters global awareness on the vital role of water in sustaining life and ecosystems.",
      "It empowers individuals to conserve and manage this precious resource, promoting responsible consumption and environmental stewardship.",
      "Such education cultivates a collective commitment towards ensuring equitable access to clean water, essential for a sustainable and healthier future.",
      "This lens also provides the UN guidelines for the World Water Day.",
    ],
    type: "personal",
    tryIt:
      "https://www.snapchat.com/unlock/?type=SNAPCODE&uuid=741c5723d22643d29e6671515299eae7&metadata=01",
    underType: "snap",
    videoLink:
      "https://res.cloudinary.com/dxhvvxfqf/video/upload/v1702271188/Website%20Videos/Personal/World_Water_Day_bqxul0.mp4",
    thumbnail:
      "https://res.cloudinary.com/dxhvvxfqf/image/upload/f_auto,q_auto/v1/Thumbnails/WorldWaterDay_k6wqap",
  },
  {
    name: "Hindi Swar",
    through: "by @palkagrecha",
    point: [
      "The aim is to transform Education through AR",
      "Make learning easy through real-time visualization, focusing on vowels (Swar - सव् र) in Hindi",
      "The effect activates upon detecting the user's face",
      "A 2D plane hovers above the user's head with a face mesh containing clues on the cheeks",
      "The filter includes a picker UI with options for all 13 sets of different vowels in Hindi",
      "User selection triggers the pronunciation audio of the chosen vowel",
      "On-screen instruction: 'Tap to Start'",
      "User taps the screen to reveal the answer for each vowel, displayed above their head",
      "Images representing answers accompany the display, along with audio for better understanding",
    ],
    tryIt: "https://www.instagram.com/ar/737249110165873/",
    type: "personal",
    underType: "insta",
    videoLink:
      "https://res.cloudinary.com/dxhvvxfqf/video/upload/f_auto:video,q_auto/v1/Website%20Videos/Personal/HindiSwaarKid_sg80ph",
    thumbnail:
      "https://res.cloudinary.com/dxhvvxfqf/image/upload/f_auto,q_auto/v1/Thumbnails/Hindi_Swar_eoehw2",
  },
  {
    name: "VCR Vibes",
    through: "by @palkagrecha",
    point: [
      "Provides an aesthetic feel of the Video Cassette Recorder (VCR)",
      "Includes date and play text on the screen, changing with a screen tap",
    ],
    tryIt: "https://www.instagram.com/ar/480205086461974/",
    type: "personal",
    underType: "insta",
    videoLink:
      "https://res.cloudinary.com/dxhvvxfqf/video/upload/v1702271190/Website%20Videos/Personal/VCRvibes_bj2nb2.mp4",
    thumbnail:
      "https://res.cloudinary.com/dxhvvxfqf/image/upload/f_auto,q_auto/v1/Thumbnails/VCR_Vibes_ff4q2o",
  },
  {
    name: "ScreenSave",
    through: "by @palkagrecha",
    point: [
      "“Coinbase kicked off the Super Bowl with a simple ad featuring a QR code styled like the bouncing icon of a DVD screensaver.",
      "Well what if we could create our own screensave-errrr, using an AR Effect?",
      "When the user taps on the screen the bouncing mechanism starts. When it touches the user’s device border it changes its color.",
      "Just like how it used to be in the earlier DVD player’s screensaver.",
      "Users can add the media from their gallery as well. The dimensions of the plane will get adjusted according to the user’s smartphone dimensions or the media added by the users from the gallery.",
    ],
    tryIt: "https://www.instagram.com/ar/321838249913002/",
    type: "personal",
    underType: "insta",
    videoLink:
      "https://res.cloudinary.com/dxhvvxfqf/video/upload/v1702271177/Website%20Videos/Personal/ScreenSaver_xidbzk.mp4",
    thumbnail:
      "https://res.cloudinary.com/dxhvvxfqf/image/upload/f_auto,q_auto/v1/Thumbnails/ScreenSave_vkrd0y",
  },
  {
    name: "Trippin",
    through: "by @palkagrecha",
    point: [
      "Filter created using Render Passes to bypass Spark AR Studio’s default render pipeline",
      "Intuitive effects with delay frame",
      "Includes RGB shaders with Kira-Kira effect for a trippy vibe",
    ],
    tryIt: "https://www.instagram.com/ar/517088132789624/",
    type: "personal",
    underType: "insta",
    videoLink:
      "https://res.cloudinary.com/dxhvvxfqf/video/upload/v1702271181/Website%20Videos/Personal/Trippin_klgtxv.mp4",
    thumbnail:
      "https://res.cloudinary.com/dxhvvxfqf/image/upload/f_auto,q_auto/v1/Thumbnails/Trippin_wvgx3v",
  },
  {
    name: "Sci-fi Cloak",
    through: "by @palkagrecha",
    point: [
      "Step into the future with the Sci-fi Cloak Snapchat Lens.",
      "Enveloping users in a sleek, high-tech full-body suit.",
      "Camouflage yourself in innovation and style as you explore a world of augmented reality.",
      "Unleash your inner sci-fi hero and embrace the allure of advanced technology in every snap.",
    ],
    tryIt:
      "https://www.snapchat.com/unlock/?type=SNAPCODE&uuid=39494bedb90a471084f4351fac77b16e&metadata=01",
    type: "personal",
    underType: "snap",
    videoLink:
      "https://res.cloudinary.com/dxhvvxfqf/video/upload/v1702271174/Website%20Videos/Personal/Sci-fi_Cloak_psxksi.mp4",
    thumbnail:
      "https://res.cloudinary.com/dxhvvxfqf/image/upload/f_auto,q_auto/v1/Thumbnails/Sci-fi_Cloak_xml8m9",
  },
  {
    name: "Pride Rays",
    through: "by @palkagrecha",
    point: [
      "Filter dedicated to the Pride community to show support and acknowledge their struggles.",
      "Projects a beam of rays in Pride colors coming out of the user's eyes.",
    ],
    tryIt: "https://www.instagram.com/ar/233520225342022/",
    type: "personal",
    underType: "insta",
    videoLink:
      "https://res.cloudinary.com/dxhvvxfqf/video/upload/f_auto:video,q_auto/v1/Website%20Videos/Personal/Pride_ray_l0myg2",
    thumbnail:
      "https://res.cloudinary.com/dxhvvxfqf/image/upload/f_auto,q_auto/v1/Thumbnails/Pride_Rays_cxhzju",
  },
  {
    name: "Plum Martini",
    through: "by @palkagrecha",
    point: [
      "Filter contains a Purple Martini Look-Up table (LUT).",
      "LUT designed in Adobe Photoshop by playing with Hue & Saturation values.",
    ],
    tryIt: "https://www.instagram.com/ar/1126360784444710/",
    type: "personal",
    underType: "insta",
    videoLink:
      "https://res.cloudinary.com/dxhvvxfqf/video/upload/f_auto:video,q_auto/v1/Website%20Videos/Personal/PlumMartini_bzpwmp",
    thumbnail:
      "https://res.cloudinary.com/dxhvvxfqf/image/upload/f_auto,q_auto/v1/Thumbnails/Plum_Martini_ibyivq",
  },

  {
    name: "My Dream",
    through: "by @palkagrecha",
    point: [
      "This Snapchat lens was created for the nationwide Lensathon.",
      "The theme of the competition was #CelebrateTheDifferences for the International Women's Day.",
      "My Dream: She can be what she decides to be, an Entrepreneur, a Sports Person, an Army Personal, an Astronaut, an Architect and whatnot!",
    ],
    tryIt:
      "https://www.snapchat.com/unlock/?type=SNAPCODE&uuid=525e2180e1e840e8b80a2c9b7c634193&metadata=01",
    type: "personal",
    underType: "snap",
    videoLink:
      "https://res.cloudinary.com/dxhvvxfqf/video/upload/f_auto:video,q_auto/v1/Website%20Videos/Personal/MyDream_gyjtsl",
    thumbnail:
      "https://res.cloudinary.com/dxhvvxfqf/image/upload/f_auto,q_auto/v1/Thumbnails/My_Dream_dgbr4n",
  },
  {
    name: "Navi Shades",
    through: "by @palkagrecha",
    point: [
      "Filter designed using the concept of Signed Distance Field (SDF) shapes.",
      "Procedural texture created in META SPARK Studio.",
      "Union of unique SDF shapes converts the texture output of the signed distance into a creative design mask as a function of the UV coordinate.",
    ],
    tryIt: "https://www.instagram.com/ar/4489557951094188/",
    type: "personal",
    underType: "insta",
    videoLink:
      "https://res.cloudinary.com/dxhvvxfqf/video/upload/f_auto:video,q_auto/v1/Website%20Videos/Personal/Navi_Shades_uqffoc",
    thumbnail:
      "https://res.cloudinary.com/dxhvvxfqf/image/upload/f_auto,q_auto/v1/Thumbnails/Navi_Shades_tbsowy",
  },
  {
    name: "Frontline Sketch",
    through: "by @palkagrecha",
    point: [
      "Designed for country-wide Hackathon and themed around frontline workers",
      "Expresses gratitude to all frontline workers during the pandemic",
      "Utilizes Look-Up Table (LUT) for posterization texture, Person Segmentation with different Render Pass, and Delay Frame",
    ],
    tryIt: "https://www.instagram.com/ar/512489746605539/",
    type: "personal",
    underType: "insta",
    videoLink:
      "https://res.cloudinary.com/dxhvvxfqf/video/upload/f_auto:video,q_auto/v1/Website%20Videos/Personal/FrontlineSketch_biwj6m",
    thumbnail:
      "https://res.cloudinary.com/dxhvvxfqf/image/upload/f_auto,q_auto/v1/Thumbnails/Frontline_Sketch_dmlqir",
  },

  {
    name: "Halloween Ghost",
    through: "by @palkagrecha",
    point: [
      "Transform into an ethereal being with the Halloween Ghost using this Snapchat lens.",
      "It is draped in a spectral white shroud, hauntingly elegant.",
      "Unleash your inner ghost and haunt your snaps with an eerie charm.",
      "A touch of spooky fun for your Halloween selfies, invoking the spirit of the season.",
    ],
    tryIt:
      "https://www.snapchat.com/unlock/?type=SNAPCODE&uuid=935e8aba8dc44365b958d183223d7b98&metadata=01",
    type: "personal",
    underType: "snap",
    videoLink:
      "https://res.cloudinary.com/dxhvvxfqf/video/upload/f_auto:video,q_auto/v1/Website%20Videos/Personal/Halloween_GHost_r8urhm",
    thumbnail:
      "https://res.cloudinary.com/dxhvvxfqf/image/upload/f_auto,q_auto/v1/Thumbnails/Halloween_Ghost_e0hrdk",
  },
  {
    name: "Curves",
    through: "by @palkagrecha",
    point: [
      "Uses the Vertex Displacement Technique with Vertex Transform patch & Vertex Attribute patch.",
      "Creates a wave-like feel.",
      "UI Picker gives users an option to choose between horizontal & vertical displacement.",
    ],
    tryIt: "https://www.instagram.com/ar/1707012712820154/",
    type: "personal",
    underType: "insta",
    videoLink:
      "https://res.cloudinary.com/dxhvvxfqf/video/upload/f_auto:video,q_auto/v1/Website%20Videos/Personal/Curves_kfflwc",
    thumbnail:
      "https://res.cloudinary.com/dxhvvxfqf/image/upload/f_auto,q_auto/v1/Thumbnails/Curves_yq3hsk",
  },
  {
    name: "Glow",
    through: "by @palkagrecha",
    point: [
      "Beautification AR filter.",
      "Adds facial makeup, including Blush, Nose Highlight, and Glossiness, on the user’s face.",
    ],
    tryIt: "https://www.instagram.com/ar/806296009945398/",
    type: "personal",
    underType: "insta",
    videoLink:
      "https://res.cloudinary.com/dxhvvxfqf/video/upload/f_auto:video,q_auto/v1/Website%20Videos/Personal/Glow_borip6",

    thumbnail:
      "https://res.cloudinary.com/dxhvvxfqf/image/upload/f_auto,q_auto/v1/Thumbnails/Glow_kabjny",
  },
  // {
  //   name: "Rahul Kumar",
  //   through: "by @palkagrecha",
  //   point: [],
  //   type: "personal",
  //   underType: "snap",
  //   videoLink:
  //     "https://res.cloudinary.com/dxhvvxfqf/video/upload/f_auto:video,q_auto/v1/Website%20Videos/Personal/GuessTheFoodDemo_hctjoc",
  // },

  // {
  //   name: "shivam Kumar",
  //   through: "by @palkagrecha",
  //   point: [],
  //   type: "client",
  //   underType: "insta",
  //   videoLink:
  //     "https://res.cloudinary.com/dxhvvxfqf/video/upload/f_auto:video,q_auto/v1/Website%20Videos/Client/AR_Game_Preview_ikr9el",
  // },
  // {
  //   name: "Roman Kumar",
  //   through: "by @palkagrecha",
  //   point: [],
  //   type: "client",
  //   underType: "insta",
  //   videoLink:
  //     "https://res.cloudinary.com/dxhvvxfqf/video/upload/v1702271017/Website%20Videos/Client/Gangaikonda_Temple_Lens_tg0rdj.mp4",
  // },

  
  // {
  //   name: "Manish Kumar",
  //   through: "by @palkagrecha",
  //   point: [],
  //   type: "client",
  //   underType: "snap",
  //   videoLink:
  //     "https://res.cloudinary.com/dxhvvxfqf/video/upload/v1702270980/Website%20Videos/Client/Gulki_Fans_fz4qqk.mp4",
  // },
];
